/* prettier-ignore */

import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'cicerone-register-step-sub-interest-type',
  templateUrl: './sub-interest-type.component.html',
  styleUrls: ['./sub-interest-type.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class RegisterSubInterestTypeComponent {
    @Input('category') category?:any;
    @Input('isRegisterStandaloneApp') isRegisterStandaloneApp: boolean = false;
    
    constructor( public translate: TranslateService, public modalCtrl: ModalController, public tools: ToolsService) {}

    setCategory(){
        if (this.isAnySubcategorySelected()){
            this.category.selected = false;
            return;
        }
        this.category.selected = !this.category.selected;
    }

    setSelectedOption(item){
        item.selected = !item.selected;
        if (item.selected)
            this.category.selected = false;
    }

    focusin(evt) {
        evt.stopPropagation();
    }

    closeModal(){
        this.modalCtrl.dismiss();
    }

    isAnySubcategorySelected(){
        return this.category.subcategories.some(subcategory => subcategory.selected)
    }

    sendData(){
        this.modalCtrl.dismiss(this.category);
    }
    
}